import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { ReactComponent as ICON_DOUBLE_ARROW_LEFT } from "@assets/svgs/ICON_DOUBLE_ARROW_LEFT.svg";
import { ReactComponent as ICON_DOUBLE_ARROW_RIGHT } from "@assets/svgs/ICON_DOUBLE_ARROW_RIGHT.svg";
import { ReactComponent as ICON_SINGLE_ARROW_LEFT } from "@assets/svgs/ICON_SINGLE_ARROW_LEFT.svg";
import { ReactComponent as ICON_SINGLE_ARROW_RIGHT } from "@assets/svgs/ICON_SINGLE_ARROW_RIGHT.svg";
import { Button } from "@components/Button";
import { COLOR_BLACK, COLOR_WHITE } from "@static/COLORS";

const LIMIT_SHOW_PAGE = 5;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

const buttonInLineStyle = {
  width: 30,
  height: 30,
  border: `1px solid transparent`,
  color: COLOR_BLACK,
  background: COLOR_WHITE,
};

const buttonInLineStyleActive = {
  width: 30,
  height: 30,
  border: `1px solid #0c9`,
  color: "#0c9",
  background: COLOR_WHITE,
};
export default ({
  currentPage = 1,
  totalPage = 1,
  onHandleChangePage = () => undefined,
}) => {
  const getPagesToShow = ({ currentPage, totalPage }) => {
    const mid = Math.floor(LIMIT_SHOW_PAGE / 2);
    let startPage = Math.max(1, currentPage - mid);
    let endPage = startPage + LIMIT_SHOW_PAGE - 1;

    if (endPage > totalPage) {
      startPage = Math.max(1, totalPage - LIMIT_SHOW_PAGE + 1);
      endPage = totalPage;
    }
    return _.range(startPage, endPage + 1);
  };

  const pagesToShow = getPagesToShow({ currentPage, totalPage });

  return (
    <Container>
      {/* section button previous */}
      {/* <Button
        style={buttonInLineStyle}
        disabled={currentPage === 1}
        onClick={() => onHandleChangePage({ page: 1 })}
      > */}
      <Button
        padding={0}
        style={buttonInLineStyle}
        disabled={currentPage === 1}
        onClick={() => onHandleChangePage({ page: 1 })}
      >
        <ICON_DOUBLE_ARROW_LEFT width={32} height={32} />
      </Button>

      {/* </Button> */}
      <Button
        padding={0}
        style={buttonInLineStyle}
        disabled={currentPage === 1}
        onClick={() => onHandleChangePage({ page: currentPage - 1 })}
      >
        <ICON_SINGLE_ARROW_LEFT width={32} height={32} />
      </Button>
      {/* section button previous */}
      {_.map(pagesToShow, (page) => {
        return (
          <Button
            key={page}
            style={
              page === currentPage ? buttonInLineStyleActive : buttonInLineStyle
            }
            onClick={() => onHandleChangePage({ page })}
          >
            {page}
          </Button>
        );
      })}
      {/* section button next */}
      {/* <Button
        style={buttonInLineStyle}
        disabled={currentPage === totalPage}
        onClick={() => onHandleChangePage({ page: currentPage + 1 })}
      >
        {">"}
      </Button>
      <Button
        style={buttonInLineStyle}
        disabled={currentPage === totalPage}
        onClick={() => onHandleChangePage({ page: totalPage })}
      >
        {">>"}
      </Button> */}

      <Button
        padding={0}
        style={buttonInLineStyle}
        disabled={currentPage === totalPage}
        onClick={() => onHandleChangePage({ page: currentPage + 1 })}
      >
        <ICON_SINGLE_ARROW_RIGHT width={32} height={32} />
      </Button>

      <Button
        padding={0}
        style={buttonInLineStyle}
        disabled={currentPage === totalPage}
        onClick={() => onHandleChangePage({ page: totalPage })}
      >
        <ICON_DOUBLE_ARROW_RIGHT width={32} height={32} />
      </Button>

      {/* </Button> */}

      {/* section button next */}
    </Container>
  );
};
